export const FETCHING_ADDRESS_PREDICTIONS = 'FETCHING_ADDRESS_PREDICTIONS';
export const PENDING_ADDRESS_PREDICTIONS_FETCH = 'PENDING_ADDRESS_PREDICTIONS_FETCH';
export const SET_ADDRESS_PREDICTIONS = 'SET_ADDRESS_PREDICTIONS';
export const SET_HAS_SEEN_ERROR = 'SET_HAS_SEEN_ERROR';
export const FAILED_FETCHING_ADDRESS_PREDICTIONS = 'FAILED_FETCHING_ADDRESS_PREDICTIONS';
export const CLEAR_ADDRESS_PREDICTIONS = 'CLEAR_ADDRESS_PREDICTIONS';
export const CLEAR_ADDRESS_INPUT = 'CLEAR_ADDRESS_INPUT';
export const UPDATE_ADDRESS_INPUT = 'UPDATE_ADDRESS_INPUT';
export const SET_ACTIVE_PREDICTION = 'SET_ACTIVE_PREDICTION';
export const FETCHING_ADDRESS_DETAILS = 'FETCHING_ADDRESS_DETAILS';
export const FAILED_FETCHING_ADDRESS_DETAILS = 'FAILED_FETCHING_ADDRESS_DETAILS';
export const SET_SELECTED_ADDRESS = 'SET_SELECTED_ADDRESS';
export const FORCE_ADDRESS_VALIDATION = 'FORCE_ADDRESS_VALIDATION';
export const SET_SHOULD_DISPLAY_COMPONENT = 'SET_SHOULD_DISPLAY_COMPONENT';
export const SET_API_FALIURE_STATE = 'SET_API_FALIURE_STATE';
